import { BulbFilled, BulbOutlined } from "@ant-design/icons";
import { Button, Card, Col, Divider, Modal, Row, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { GetDataFromServer, updateUserDataOnServer } from "../../lib/api";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import ResetModal from "./reset_modal";
import { AGENT_EDIT_SELF, AGENT_LIST } from "../../lib/config";
import { moneyFormat } from "../../lib/global_functions";
import moment from "moment-timezone";
import { setState } from "../../redux/user";
import Transaction from "../transaction/transaction";
import SettingTransactionPage from "./setting_transaction";

const { Text } = Typography;

export default function Setting() {
  const user = useSelector((state) => state.user);

  const [themeLoading, setThemeLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const dispatch = useDispatch();

  async function getRefreshDataList() {
    await GetDataFromServer(AGENT_LIST, user.access_token)
      .then((res) => {
        dispatch(
          setState({
            ...user,
            name: res.data.name,
            email: res.data.email,
            phone: res.data.phone,
            address: res.data.address,
            points: res.data.points,
            total_deposit_points: res.data.total_deposit_points,
            total_withdraw_points: res.data.total_withdraw_points,
          })
        );
      })
      .catch((error) => {
        toast.error(error?.response.data || "Connection Error");
      });
  }

  useEffect(() => {
    getRefreshDataList();
  }, []);

  async function themeChanger(value, type) {
    console.log("theme change");
    const validOptions = {
      theme: ["dark", "white"],
      ui_size: ["small", "normal", "large"],
    };

    if (!validOptions[type]?.includes(value)) return;

    const requestObject = { [type]: value.toUpperCase() };

    const reduxStoreType = {
      theme: "select_theme",
      ui_size: "ui_size",
    };

    let reduxStore = reduxStoreType[type];

    setThemeLoading(true);

    await updateUserDataOnServer(
      AGENT_EDIT_SELF,
      requestObject,
      user.access_token,
      user.csrf_token
    )
      .then(() => {
        setThemeLoading(false);
        dispatch(setState({ ...user, [reduxStore]: value }));
      })
      .catch((error) => {
        setThemeLoading(false);
        toast.error(error?.response?.data?.error || "Connection Error");
      });
  }

  const columns = [
    {
      title: "Amount",
      dataIndex: "amount",
      render: (_, record) => {
        return (
          <Text>
            {record.amount}{" "}
            <Text style={{ color: "green" }}>({record.currency})</Text>
          </Text>
        );
      },
    },
    {
      title: "Points",
      dataIndex: "points",
    },
    {
      title: "Date",
      dataIndex: "created_at",
      render: (created_at) =>
        moment.utc(created_at).tz("Asia/Yangon").format("DD-MM-YYYY, HH:mm:ss"),
    },
  ];

  return (
    <>
      <Row gutter={[16, 24]}>
        <Col span={12}>
          <Card size={user.ui_size} title="User Profile">
            <Row gutter={[24, 16]}>
              <Col span={8}>
                <Text>Code</Text>
              </Col>
              <Col span={16}>
                <Text>{user.code}</Text>
              </Col>

              <Col span={8}>
                <Text>Name</Text>
              </Col>
              <Col span={16}>
                <Text>{user.name}</Text>
              </Col>

              <Col span={8}>
                <Text>Email</Text>
              </Col>
              <Col span={16}>
                <Text>{user.email}</Text>
              </Col>

              <Col span={8}>
                <Text>Phone</Text>
              </Col>

              <Col span={16}>
                <Text>{user.phone}</Text>
              </Col>

              <Col span={8}>
                <Text>Address</Text>
              </Col>
              <Col span={16}>
                <Text>{user.address ? user.address : "-"}</Text>
              </Col>
              <Col span={8}>
                <Text>Points</Text>
              </Col>
              <Col span={16}>
                <Text>{moneyFormat(user.points)}</Text>
              </Col>
              <Col span={8}>
                <Text>Total Deposit Points</Text>
              </Col>
              <Col span={16}>
                <Text>{moneyFormat(user.total_deposit_points)}</Text>
              </Col>

              <Col span={8}>
                <Text>Total Withdraw Points</Text>
              </Col>
              <Col>
                <Text>{moneyFormat(user.total_withdraw_points)}</Text>
              </Col>
              <Col span={24}>
                <Divider />
              </Col>

              <Col span={24}>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    size={user.ui_size}
                    type="primary"
                    onClick={() => setShowModal(true)}
                  >
                    Password Reset
                  </Button>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col span={12}>
          <Card title="System Settings">
            <Row gutter={[24, 16]}>
              <Col span={8}>
                <Text>Theme</Text>
              </Col>
              <Col span={16}>
                <Row gutter={16}>
                  <Col>
                    <Button
                      size={user.ui_size}
                      icon={<BulbOutlined />}
                      loading={themeLoading}
                      disabled={user.select_theme === "dark"}
                      onClick={() => themeChanger("dark", "theme")}
                    >
                      Dark
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      size={user.ui_size}
                      icon={<BulbFilled />}
                      loading={themeLoading}
                      disabled={user.select_theme !== "dark"}
                      onClick={() => themeChanger("white", "theme")}
                    >
                      White
                    </Button>
                  </Col>
                </Row>
              </Col>

              <Col span={8}>
                <Text>Ui Size</Text>
              </Col>
              <Col span={16}>
                <Row gutter={16} align={"middle"}>
                  <Col>
                    <Button
                      disabled={user.ui_size === "small"}
                      size="small"
                      loading={themeLoading}
                      onClick={() => themeChanger("small", "ui_size")}
                    >
                      Small
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      disabled={user.ui_size === "normal"}
                      size="normal"
                      loading={themeLoading}
                      onClick={() => themeChanger("normal", "ui_size")}
                    >
                      Normal
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      disabled={user.ui_size === "large"}
                      size="large"
                      loading={themeLoading}
                      onClick={() => themeChanger("large", "ui_size")}
                    >
                      Large
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
      <Row style={{ marginTop: "40px" }}>
        <SettingTransactionPage />
      </Row>

      <Modal
        size={user.ui_size}
        footer={null}
        title="Password Reset"
        open={showModal}
        onCancel={() => setShowModal(false)}
        destroyOnClose
      >
        <ResetModal />
      </Modal>
    </>
  );
}
